import React from "react";
import { Outlet } from "react-router-dom";

function ServiceProvider() {
  return <Outlet />;
}

export default ServiceProvider;
